import { DoudianPeriodPurchaseInfo } from "@/dto/order/DouDianOrderExtraInfoDTO";
import OrderItemDTO from "@/dto/order/OrderItemDTO";
import OrderStatus from "@/enum/OrderStatus";
import moment from "moment";

/** 周期购 */

/**
 * 将周期信息进行降序排序
 */
function getSortedPeriodPurchaseInfoList(periodPurchaseInfoList: DoudianPeriodPurchaseInfo[]) {
    if (!periodPurchaseInfoList?.length) return periodPurchaseInfoList;

    const sortedPeriodPurchaseInfoList = [...periodPurchaseInfoList]
        .filter(({ deliverTime }) => deliverTime)
        .sort((prev, next) => next.deliverTime - prev.deliverTime);

    return sortedPeriodPurchaseInfoList;
}

export function findPeriodPurchaseInfoByOrderItemOriginalId(
    periodPurchaseInfoList: DoudianPeriodPurchaseInfo[],
    originalId: string,
) {
    const sortedPeriodPurchaseInfoList = getSortedPeriodPurchaseInfoList(periodPurchaseInfoList);

    return sortedPeriodPurchaseInfoList.find((it) => it.orderItemId === originalId);
}

/**
 * 找到时间最早的待发货的 PeriodPurchaseInfo
 */
export function findClosestPendingPeriodPurchaseInfo(
    periodPurchaseInfoList: DoudianPeriodPurchaseInfo[],
    orderItems: OrderItemDTO[],
) {
    if (!periodPurchaseInfoList?.length || !orderItems?.length) return null;

    const orderItemStatusMap = new Map();
    orderItems.forEach((item) => {
        orderItemStatusMap.set(item.originalId, item.status);
    });

    // 筛选出待发货的 PeriodPurchaseInfo
    const pendingPeriodInfos = periodPurchaseInfoList.filter((info) => {
        const status = orderItemStatusMap.get(info.orderItemId);
        return status === OrderStatus.PENDING_SHIPMENT;
    });

    // 没有待发货项
    if (pendingPeriodInfos.length === 0) {
        return null;
    }

    return pendingPeriodInfos.reduce((earliest, current) => {
        if (!current?.deliverTime) return earliest;

        return new Date(current.deliverTime).getTime() < new Date(earliest.deliverTime).getTime() ? current : earliest;
    });
}

export function getPeriodPurchaseDeliverTypeInfo(deliverType: number) {
    switch (deliverType) {
        case 5:
            return "预约送达时间";
        case 6:
            return "预约发货时间";
        default:
            return null;
    }
}

/** -------------------------- */
